/*我的团队相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../../axios'
export default {
    getList: (data) => axios.get('/api/api/request/log/visitor', data),//获取访客记录列表
    getCount: () => axios.get('/api/api/request/log/count'),//访客记今日/历史数量
    getLogs: (data) => axios.get('/api/api/request/log/user', data),//获取用户访客详情
}